import './CTUS.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class CTUS extends PageManager {

	constructor (pageContext) {
		super(pageContext);
	}

	onReady () {
		this.initContactUsForm();
	}

	initContactUsForm () {
		const contactUsFormElement = document.getElementById('js-contact-us-form');

		if (!contactUsFormElement) {
			return;
		}

		contactUsFormElement.addEventListener('submit', this.handleContactUsFormSubmit.bind(this));
	}

	// eslint-disable-next-line max-lines-per-function
	async handleContactUsFormSubmit (event) {
		const formElement = event.target;
		const formSubmitElement = formElement?.querySelector('[type="submit"]');
		const requestUrl = this.pageContext.Japi_Url;
		const messageElement = document.getElementById('js-contact-us-form-message');

		if (!formElement || !formSubmitElement || !requestUrl || !messageElement) {
			return;
		}

		event.preventDefault();

		messageElement.className = 'u-hidden';
		messageElement.innerHTML = '';

		const submittingClass = 'g-button--submitting';

		formSubmitElement.disabled = true;
		formSubmitElement.classList.add(submittingClass);

		const formData = new FormData(formElement);

		const contactEmail = formData.get('contact_email') ?? '';
		const contactName = formData.get('contact_name') ?? '';
		const storeEmail = window.atob(formData.get('store_email') ?? '');
		const storeName = formData.get('store_name') ?? '';

		const emailMsg = `
			<p>Hello ${storeName},</p>
			<p>Your contact form has been submitted by <strong>${contactName}</strong>.</p>
			<p>Here is the customer's information:</p>
			<p>
				<strong>Name:</strong> ${contactName}<br />
				<strong>E-mail Address:</strong> <a href='mailto:${contactEmail}'>${contactEmail}</a><br />
				<strong>Address:</strong><br />
				${formData.get('contact_address') ?? ''}<br />
				${formData.get('contact_city') ?? ''} ${formData.get('contact_state') ?? ''}, ${formData.get('contact_zip') ?? ''} ${formData.get('contact_country') ?? ''}<br />
				<strong>Their Questions or Comments:</strong><br />
				${formData.get('contact_comment') ?? ''}
			</p>
		`;

		/* eslint-disable camelcase */
		const response = await fetch(requestUrl, {
			body: JSON.stringify({
				email: {
					from: storeEmail,
					headers: [
						`Reply-To: ${contactName} <${contactEmail}>`,
						`Return-Path: ${contactName} <${contactEmail}>`
					],
					message: emailMsg.trim(),
					subject: `Your ${storeName} Contact Form Has Been Submitted`,
					to: storeEmail
				},
				function: 'send-email'
			}),
			headers: {
				'Content-Type': 'application/json'
			},
			method: 'POST'
		});
		/* eslint-enable camelcase */

		formSubmitElement.disabled = false;
		formSubmitElement.classList.remove(submittingClass);

		if (!response.ok) {
			throw Error(response.statusText);
		}

		if (!messageElement) {
			return;
		}

		let submitMessage = 'Error: We\'re sorry, there was a problem processing your request.';
		let messageType = 'error';

		const responseData = await response.json();

		if (responseData.success) {
			submitMessage = `Thank you for your inquiry. A ${storeName} representative will contact you shortly.`;
			messageType = 'success';

			formElement.reset();
		}

		messageElement.innerHTML = submitMessage;
		messageElement.className = `g-messages g-messages--${messageType}`;

		messageElement.scrollIntoView({
			behavior: 'smooth',
			block: 'center'
		});
	}
};
